export default {
  SET_ACTIVE_EXPOSURE_PART(state, payload) {
    state.activeExposurePart = payload
    state.activeTypeEntityItem = {}
  },
  SET_EXPOSURE_PART_OPTIONS(state, payload) {
    state.exposurePartOptions = payload
  },
  SET_ACTIVE_EXPOSURE_TABLE(state, payload) {
    state.activeExposureTable = payload
  },
  SET_EXPOSURE_TABLE_OPTIONS(state, payload) {
    state.exposureTableOptions = payload
  },
  SET_ACTIVE_PART_BAR(state, payload) {
    state.activePartBar = payload
    state.activeTypeEntityItem = {}
  },
  SET_PART_BAR_OPTIONS(state, payload) {
    state.partBarOptions = payload
  },
  SET_ACTIVE_SORT(state, payload) {
    state.activeSort = payload
  },
  SET_ACTIVE_TYPE_ENTITY_ITEM(state, payload) {
    state.activeTypeEntityItem = payload
  },
  SET_ACTIVE_PART_BAR_UOF(state, payload) {
    state.activePartBarUof = payload
  },
  SET_ACTIVE_PART_BAR_FULL(state, payload) {
    state.activePartBarFull = payload
  },
  SET_ACTIVE_EXPOSURE_PART_UOF(state, payload) {
    state.activeExposurePartUof = payload
    state.activeTypeEntityItemUof = {}
  },
  SET_ACTIVE_EXPOSURE_PART_FULL(state, payload) {
    state.activeExposurePartFull = payload
    state.activeTypeEntityItemFull = {}
  },
  SET_ACTIVE_TYPE_ENTITY_ITEM_UOF(state, payload) {
    state.activeTypeEntityItemUof = payload
  },
  SET_ACTIVE_TYPE_ENTITY_ITEM_FULL(state, payload) {
    state.activeTypeEntityItemFull = payload
  },
  RESET_REPORT_STATE(state) {
    state.activeExposurePart = { name: 'Full Exposure', value: 'full' }
    state.exposurePartOptions = [
      { name: 'Full Exposure', value: 'full' },
      { name: 'Source of Funds', value: 'incoming' },
      { name: 'Use of Funds', value: 'outgoing' },
    ]
    state.activePartBar = { name: 'Risk Labels', value: 'type' }
    state.partBarOptions = [
      { name: 'Risk Labels', value: 'type' },
      { name: 'Entity', value: 'entity' },
    ]
    state.activeTypeEntityItem = {}

    state.activePartBarUof = { name: 'Risk Labels', value: 'type' }
    state.activePartBarFull = { name: 'Risk Labels', value: 'type' }
    state.activeExposurePartUof = { name: 'Full Exposure', value: 'full' }
    state.activeExposurePartFull = { name: 'Full Exposure', value: 'full' }
    state.activeTypeEntityItemUof = {}
    state.activeTypeEntityItemFull = {}
  },
}
